<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'AssetsSection',
  mounted() {
    this.SET_SECTION('Assets');
  },
  methods: {
    ...mapMutations(['SET_SECTION']),
  },
};
</script>
